/* ÌTURA — Figma PDP behaviour.
   Only the detail-tab row needs JS; the claim-row drawers reuse the theme's own
   <x-modal>, which the theme binds through aria-controls. */

if (!customElements.get('itura-tabs')) {
  customElements.define(
    'itura-tabs',
    class IturaTabs extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this._onClick);
        this.addEventListener('keydown', this._onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('keydown', this._onKeydown);
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[data-itura-tab]'));
      }

      _onClick = (event) => {
        const tab = event.target.closest('[data-itura-tab]');
        if (tab && this.contains(tab)) this.select(tab.dataset.ituraTab);
      };

      _onKeydown = (event) => {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        const tab = event.target.closest('[data-itura-tab]');
        if (!tab || !this.contains(tab)) return;

        const tabs = this.tabs;
        const current = tabs.indexOf(tab);
        let next = current;

        if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;

        event.preventDefault();
        this.select(tabs[next].dataset.ituraTab);
        tabs[next].focus();
      };

      select(id) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.ituraTab === id;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        this.querySelectorAll('[data-itura-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.ituraPanel !== id;
        });
      }
    }
  );
}
